import Hero from "@/components/Hero";
import PressTicker from "@/components/PressTicker";
import EditorialMarquee from "@/components/EditorialMarquee";
import Pathways from "@/components/Pathways";
import WhyMagnetic from "@/components/WhyMagnetic";
import HiddenPlacement from "@/components/HiddenPlacement";
import Anatomy from "@/components/Anatomy";
import { EquipmentSection, FleetSection, PersonalSection, VehiclesSection } from "@/components/Sections";
import HowItWorks from "@/components/HowItWorks";
import BundleShop from "@/components/BundleShop";
import { FinalCta, Policies, WhyTracksy } from "@/components/Trust";
import TeamStrip from "@/components/TeamStrip";
import Reviews from "@/components/Reviews";
import UgcReels from "@/components/UgcReels";
import Faq from "@/components/Faq";
import FleetEnquiry from "@/components/FleetEnquiry";
import TheftUrgency from "@/components/TheftUrgency";
import TravelCardTeaser from "@/components/TravelCardTeaser";
import { useSeo } from "@/components/Primitives";

// Flow: everyday buyer first (hero → bundles → what's in the box → why magnetic → where it hides → personal + vehicles),
// then the bridge into business (pathways → fleet → equipment → enquiry), then trust and support.
export default function Home() {
  useSeo(
    "Tracksy — Track What Matters. Magnetic tracking for your car, trailer, tools & fleet",
    "Tracksy is a compact magnetic Bluetooth tracker that works with Apple Find My. Attach it to your car, trailer, tools and everyday essentials — bundles from $29, fleet pricing for 10+."
  );
  return (
    <>
      <Hero />
      <PressTicker />
      <BundleShop showVolumeRewards={false} eyebrow="Pick your pack" title="One for the car. One for the trailer. A few for everything else." />
      <UgcReels />
      <TheftUrgency />
      <TravelCardTeaser />
      <EditorialMarquee />
      <Anatomy />
      <WhyMagnetic />
      <HiddenPlacement />
      <PersonalSection />
      <VehiclesSection />
      <Pathways />
      <FleetSection />
      <EquipmentSection />
      <HowItWorks />
      <WhyTracksy />
      <TeamStrip />
      <Reviews />
      <Faq />
      <Policies />
      <FleetEnquiry compact />
      <FinalCta />
    </>
  );
}
